import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ApplicationService, ParcelAppEntityApplicationRead, ParcelAppEntityParcelRead, ParcelAppEntityParcelWrite,
  ParcelService
} from '../openapi';
import { forkJoin, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParcelsCommonService {
  constructor(
    private parcelService: ParcelService,
    private applicationService: ApplicationService
  ) {
  }

  public updateParcels(
    currentApp: ApplicationAppEntityApplicationRead,
    payload: ApplicationAppEntityApplicationWrite,
    parcels: ParcelAppEntityParcelWrite[]
  ): Observable<ApplicationAppEntityApplicationRead> {
    const oldIds: string[] = currentApp.parcels?.map((p: ParcelAppEntityApplicationRead) => p?.uuid || '') || [];
    const deleteRequest: Observable<any> = oldIds?.length ? forkJoin(oldIds.map(id => this.parcelService.deleteParcelParcelItem({ id }))) : of([]);
    return deleteRequest.pipe(
      switchMap(() => {
        return (parcels.length ? forkJoin(
          parcels.map(parcel =>
            this.parcelService.postParcelParcelCollection({
              parcel
            })
          )
        ) : of([])).pipe(
          switchMap((p: ParcelAppEntityParcelRead[]) =>
            this.applicationService.patchApplicationApplicationItem({
              id: currentApp?.uuid || '',
              application: { ...payload, parcels: p.map(v => v?.uuid || '') }
            })
          )
        );
      })
    );
  }
}
